<template>
  <div v-if="productsData" class="table-container">
    <table class="my-table">
      <thead>
        <tr>
          <th rowspan="2">#</th>
          <th colspan="5">{{ $t("Products.data") }}</th>
          <th rowspan="2"><i class="fas fa-sliders-h"></i></th>
        </tr>
        <tr>
          <th>{{ $t("general.image") }}</th>
          <th>{{ $t("general.code") }}</th>
          <th class="cell-lg">{{ $t("general.name") }}</th>
          <th>{{ $t("price") }}</th>
          <th class="cell-lg">{{ $t("Categories.name") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(product, index) in productsData" :key="index">
          <td>{{ ++index + filterData.currentIndex }}</td>
          <td>
            <img
              class="item-img-table"
              :src="
                fullPathFileFromServer(product.productImagePath, defaultImg)
              "
              :onerror="`this.src='${defaultImg}'`"
            />
          </td>
          <td>{{ isDataExist(product.fullCode) }}</td>
          <td>
            {{ isDataExist(product.productNameCurrent) }}
          </td>
          <td>
            {{ isDataExist(product.productPriceWithCurrency) }}
          </td>
          <td>
            {{
              isDataExist(
                product.categoryInfoData
                  ? product.categoryInfoData.categoryNameCurrent
                  : ""
              )
            }}
          </td>
          <td class="fmenu-item-container">
            <FloatingMenu>
              <li>
                <button
                  @click="
                    setProductData(product);
                    openBottomSheet('ProductInfo');
                  "
                  :title="$t('info')"
                >
                  <img src="@/assets/images/info.svg" />
                </button>
              </li>
              <li>
                <button
                  @click="
                    setProductData(product);
                    openBottomSheet('ProductQRCode');
                  "
                  :title="$t('general.qrCode')"
                >
                  <img src="@/assets/images/qr-code.svg" />
                </button>
              </li>
              <li v-if="checkPrivilege(hasProductEdit())">
                <button
                  @click="
                    setProductData(product);
                    openBottomSheet('ProductUpdate');
                  "
                  :title="$t('edit')"
                >
                  <img src="@/assets/images/pencil.svg" />
                </button>
              </li>
              <li v-if="checkPrivilege(hasProductFinaleDelete())">
                <button
                  v-b-modal.ProductDelete
                  :title="$t('delete')"
                  @click="setProductData(product)"
                >
                  <img src="@/assets/images/trash.svg" />
                </button>
              </li>
              <li v-if="checkPrivilege(hasProductChangeActivationType())">
                <button
                  v-b-modal.ProductChangeActivationType
                  :title="$t('changeActivationType')"
                  @click="setProductData(product)"
                >
                  <img src="@/assets/images/changeActivationType.svg" />
                </button>
              </li>
              <li>
                <button
                  @click="
                    setProductData(product);
                    openBottomSheet('ActionsData');
                  "
                  :title="$t('actionsData.modelName')"
                >
                  <img src="@/assets/images/actions-data.svg" />
                </button>
              </li>
            </FloatingMenu>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {
  checkPrivilege,
  isDataExist,
  fullPathFileFromServer,
} from "./../../../../../utils/functions";
import {
  hasProductEdit,
  hasProductFinaleDelete,
  hasProductChangeActivationType,
} from "./../../../../../utils/privilegeHelper";
import FloatingMenu from "./../../../../../components/general/FloatingMenu.vue";
import generalMixin from "./../../../../../utils/generalMixin";

export default {
  name: "ProductsTable",
  mixins: [generalMixin],
  components: {
    FloatingMenu,
  },
  props: ["productsData", "filterData", "defaultImg"],
  methods: {
    setProductData(product) {
      this.$emit("setProductData", product);
    },
    checkPrivilege,
    isDataExist,
    fullPathFileFromServer,
    hasProductEdit,
    hasProductFinaleDelete,
    hasProductChangeActivationType,
  },
};
</script>
